import ScrollReveal from '@/components/ScrollReveal';
import SpotifyEmbed from '@/components/SpotifyEmbed';
import { useLanguage } from '@/lib/i18n';

export default function Playlist() {
  const { t } = useLanguage();

  return (
    <main id="main-content" className="pt-32 pb-24" data-testid="playlist-page">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <ScrollReveal>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#1DB954]/60 mb-4">Spotify</p>
          <h1 className="font-syne text-5xl md:text-6xl font-bold tracking-tighter mb-4" data-testid="playlist-page-title">
            {t('playlist_title')}
          </h1>
        </ScrollReveal>
        <ScrollReveal delay={0.15}>
          <SpotifyEmbed />
        </ScrollReveal>
      </div>
    </main>
  );
}
